export default "__VITE_ASSET__5280ce1a__"